import type { BankAccountType } from '@api';
import { FormProvider } from 'react-hook-form';
import { BankAccountFormFields, useEditBankAccountForm } from '../../../../common';

type ViewDeletedBankAccountFormPropsType = {
  bankAccount: BankAccountType;
  onClose: () => void;
};

export const ViewDeletedBankAccountForm: React.FC<
  ViewDeletedBankAccountFormPropsType
> = ({ bankAccount, onClose }) => {
  const form = useEditBankAccountForm(bankAccount);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit}>
        <BankAccountFormFields
          onClose={onClose}
          readOnly
          deletionReason={bankAccount.deletionReason}
        />
      </form>
    </FormProvider>
  );
};
